import {apiClient} from 'core/apiClient';
import {AuditExportFormat} from 'types/audit-log';
import {ReturnAuditEntry, ReturnAuditPage, ReturnAuditParams} from 'types/return-audit';

const URL = '/marking/return-goods/audit-log';

export async function fetchReturnAuditLog(params: ReturnAuditParams) {
    return (await apiClient.get<ReturnAuditPage>(URL, {params})).data;
}

export async function fetchReturnAuditEvent(id: string) {
    return (await apiClient.get<ReturnAuditEntry>(`${URL}/${id}`)).data;
}

export async function exportReturnAuditEvent(id: string) {
    return (await apiClient.get<Blob>(`${URL}/${id}/export`, {responseType: 'blob'})).data;
}

export async function exportReturnAuditLog(
    params: ReturnAuditParams & {format: AuditExportFormat; from: string; to: string},
) {
    return {
        data: (await apiClient.get<Blob>(`${URL}/export`, {params, responseType: 'blob'})).data,
    };
}
